import { NodeEditor } from 'rete';
import { renderConnection, renderPathData, updateConnection } from './utils';
import { Picker } from './picker';
import { Flow } from './flow';
import './events';
import './index.sass';

function install(editor: NodeEditor) {
    editor.bind('connectionpath');
    editor.bind('connectiondrop');
    editor.bind('connectionpick');
    
    const picker = new Picker(editor);
    const flow = new Flow(picker);
    const socketsParams = new WeakMap();
    
    function pointerDown(this: HTMLElement, e: PointerEvent) {
        const flowParams = socketsParams.get(this);

        if(flowParams) {
            const { input, output } = flowParams;
            
            editor.view.container.dispatchEvent(new PointerEvent('pointermove', e));
            e.preventDefault();
            e.stopPropagation();
            flow.start({ input, output }, input || output);
        }
    }

    function pointerUp(this: Window, e: PointerEvent) {
        const flowEl = document.elementFromPoint(e.clientX, e.clientY);

        if(picker.io) {
            editor.trigger('connectiondrop', picker.io)
        }
        if(flowEl) {
            flow.complete(socketsParams.get(flowEl) || {})
        }
    }


    editor.on('rendersocket', ({ el, input, output }) => {
        socketsParams.set(el, { input, output });

        el.removeEventListener('pointerdown', pointerDown);
        el.addEventListener('pointerdown', pointerDown);
    });

    window.addEventListener('pointerup', pointerUp);

    editor.on('renderconnection', ({ el, connection, points }) => {
        const d = renderPathData(editor, points, connection);

        renderConnection({ el, d, connection })
    });

    editor.on('updateconnection', ({ el, connection, points }) => {
        const d = renderPathData(editor, points, connection);

        updateConnection({ el, d });
    });

    editor.on('destroy', () => {
        window.removeEventListener('pointerup', pointerUp);
    });
}

export default {
    name: 'connection',
    install
}
export { defaultPath } from './utils';